import { useReducer, useEffect } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { GET_SUPPLINER_ORDER_SHIP } from '../../api/orderManage'
import { isResponseCodeSuccess } from '../../tools/util'
interface State {
  orderInfo: any[]
}
type ActionType = 'setOrderInfo'

interface Action {
  type: ActionType
  payload: any
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setOrderInfo':
      newstate.orderInfo = action.payload
      return newstate
  }
}

/**
 * 设置发货单列表
 * @param key
 * @returns
 */
const setOrderInfo = (val: any): Action => ({
  type: 'setOrderInfo',
  payload: val,
})

const initialState: State = {
  orderInfo: [],
}

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { orderInfo } = state
  const query = useQuery()
  const id = query.get('id') || ''
  const orderId = query.get('orderId') || ''

  useEffect(() => {
    if (id) {
      sessionStorage.setItem('SUPPLIER_ORDER_ID', id)
      getSupplierOrderList()
    }
    // eslint-disable-next-line
  }, [])

  const getSupplierOrderList = async () => {
    const res = await GET_SUPPLINER_ORDER_SHIP({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderInfo(res.data))
    }
  }
  return {
    orderInfo,
    orderId,
  }
}
import { useReducer, useEffect } from 'react'
import { useQuery } from '../../tools/utilHooks'
import { GET_SUPPLINER_ORDER_SHIP } from '../../api/orderManage'
import { isResponseCodeSuccess } from '../../tools/util'
interface State {
  orderInfo: any[]
}
type ActionType = 'setOrderInfo'

interface Action {
  type: ActionType
  payload: any
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setOrderInfo':
      newstate.orderInfo = action.payload
      return newstate
  }
}

/**
 * 设置发货单列表
 * @param key
 * @returns
 */
const setOrderInfo = (val: any): Action => ({
  type: 'setOrderInfo',
  payload: val,
})

const initialState: State = {
  orderInfo: [],
}

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { orderInfo } = state
  const query = useQuery()
  const id = query.get('id') || ''
  const orderId = query.get('orderId') || ''

  useEffect(() => {
    if (id) {
      sessionStorage.setItem('SUPPLIER_ORDER_ID', id)
      getSupplierOrderList()
    }
    // eslint-disable-next-line
  }, [])

  const getSupplierOrderList = async () => {
    const res = await GET_SUPPLINER_ORDER_SHIP({ id: id })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderInfo(res.data))
    }
  }
  return {
    orderInfo,
    orderId,
  }
}
